module.exports = __webpack_public_path__ + "static/media/background.6aa7de73.jpg";